import React from 'react';
import PropTypes from 'prop-types';
import { getInputAndLabels } from '../helper';
/**
 * Компонент радио из кнопок в длинного червяка
 */
const RadioWorm = ({
  answers,
  changeHandler
}) => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
  className: "order-review__scale"
}, getInputAndLabels({
  id: 'radio-worm',
  answers,
  changeHandler
}), /*#__PURE__*/React.createElement("div", {
  className: "order-review__scale-fill"
}), /*#__PURE__*/React.createElement("div", {
  className: "order-review__scale-background"
})), /*#__PURE__*/React.createElement("div", {
  className: "order-review__scale-grid"
}, answers.map(answer => /*#__PURE__*/React.createElement("div", {
  key: answer.id
}, answer.value))));
RadioWorm.propTypes = {
  /** Варианты ответов по вопрос */answers: PropTypes.arrayOf(PropTypes.shape({
    /** Идентификатор */id: PropTypes.number,
    /** Заголовок */value: PropTypes.number
  })),
  /** Изменение знаения инпута */changeHandler: PropTypes.func
};
export default RadioWorm;